import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { truncate } from '@bibliocommons/utils-html';

import ExpandButton from './ExpandButton';

import './ExpandableHtml.scss';

function renderHtmlText(htmlText) {
  // eslint-disable-next-line react/no-danger
  return <div className="expandable-html__text" dangerouslySetInnerHTML={{ __html: htmlText }} />;
}

const renderExpandLabel = (isExpanded, textKey) => {
  const labelKey = isExpanded ? 'read_less' : 'read_more';

  return (
    <span>
      <span aria-hidden>
        <FormattedMessage id={labelKey} />
      </span>
      <ScreenReaderMessage>
        <FormattedMessage id={`${labelKey}_${textKey}`} />
      </ScreenReaderMessage>
    </span>
  );
};

const ExpandableHtml = ({ htmlText, truncateCount, className, textKey, handleToggle: onToggle }) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setExpanded(prev => {
      const nextExpanded = !prev;
      if (onToggle) {
        onToggle(nextExpanded);
      }
      return nextExpanded;
    });
  }, [onToggle]);

  const truncatedHtml = truncate(htmlText, truncateCount);
  const anyTextTruncated = truncatedHtml.length !== htmlText.length;

  return (
    <div className={cn('cp-expandable-html', className)}>
      <div className="expandable-html__text-container">
        {renderHtmlText(expanded ? htmlText : truncatedHtml)}
        {anyTextTruncated && (
          <ExpandButton
            className="expandable-html__expand-button"
            handleToggle={handleToggle}
            isExpanded={expanded}
            renderLabel={renderExpandLabel}
            textKey={textKey}
          />
        )}
      </div>
    </div>
  );
};

ExpandableHtml.propTypes = {
  htmlText: PropTypes.string.isRequired,
  truncateCount: PropTypes.number,
  className: PropTypes.string,
  textKey: PropTypes.string.isRequired,
  handleToggle: PropTypes.func
};

ExpandableHtml.defaultProps = {
  truncateCount: 250
};

export default ExpandableHtml;
